import React from "react";
import Moment from "moment";
import _ from "lodash";
import { Link } from "react-router-dom";

const MachineOverview = (props: { machines: any }) => {
  const { machines } = props;
 

  return (
    <div>
      <div className="row">
        <h3 className="fw-bolder my-2 ms-xl-9 ms-3 mt-9 card-title align-items-start flex-column">
          <span className="card-label fw-bolder fs-3">Machines</span>
          <div className="text-muted fw-semibold fs-7 mt-2">
            Total machines : {machines.length ? machines.length : 0}
          </div>
        </h3>
        <div className="col-12">
          <div className="card mt-9 mx-xl-4">
            <div className="card-body w-100 p-5">
              <div className="table-responsive p-0 pb-2 fs-6 border-0 p-5">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                  <thead>
                    <tr className="fs-5 fw-bold">
                      <th className="fs-5 text-muted">Machine ID</th>
                      <th className="fs-5 text-muted">Serial Number</th>
                      <th className="fs-5 text-muted">Machine Name</th>
                      <th className="fs-5 text-muted">Deployment Date</th>
                      <th className="fs-5 text-muted">Machine Status</th>
                      <th className="fs-5 text-muted">Deploying Person</th>

                      <th className="fs-5 text-muted">Remark</th>
                      <th className="fs-5 text-muted">Retired At</th>
                      <th className="fs-5 text-muted">Retired By</th>
                      <th className="fs-5 text-muted">Created At</th>
                      <th className="fs-5 text-muted">Connection Status</th>
                      <th className="fs-5 text-muted">Software Version</th>
                      <th className="fs-5 text-muted"> Mechanical Hardware Version</th>
                    </tr>
                  </thead>
                  <tbody>
                    {machines.length > 0 ? (
                      Array.from(machines).map((machine: any, index) => (
                        <>
                          <tr key={index}>
                            <td>
                              <Link data-bs-toggle="tooltip" title="Click here to view machine"
                                to={`/machines/list/history/${machine.id}`}
                              >
                                {machine.uuid ?? ""}
                              </Link>
                            </td>
                            <td>{machine.serialNumber ?? ""}</td>
                            <td>{machine.name ?? ""}</td>
                            <td>
                              {Moment.unix(machine.deploymentDate / 1000)
                                .local()
                                .format("YYYY-MM-DD")}
                            </td>
                            <td>
                              {_.capitalize(
                                _.lowerCase(machine.machineStatus?.name ?? "")
                              )}
                            </td>
                            <td>{machine.deployingPerson?.firstName ?? ""}</td>
                            <td>{machine.remark ?? ""}</td>
                            <td>
                              {machine.retiredAt ? Moment.utc(machine.retiredAt  ?? "")
                                .local()
                                .format("YYYY-MM-DD HH:mm") : ""}
                            </td>
                            <td>{machine.retiredBy?.firstName ?? ""}</td>
                            <td>
                              {Moment.utc(machine.createdAt)
                                .local()
                                .format("YYYY-MM-DD HH:mm")}
                            </td>
                            <td>
                              {_.capitalize(
                                _.lowerCase(machine.connectionStatus ?? "")
                              )}
                            </td>
                            <td>{machine.softwareVersion ?? ""}</td>
                            <td>{machine.hardwareVersion ?? ""}</td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td
                            align="center"
                            className="text-center align-align-items-center justify-content-center"
                            colSpan={11}
                          >
                            No records found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MachineOverview;
